module.exports = __webpack_public_path__ + "img/BGA-logo.9f24d793.png";